import styles from './UsageBadge.module.css';

/**
 * 남은 무료 응답 횟수 표시 (기획 03 §3.1).
 * daytime_mode 인 세션은 카운트 차감 X — 다른 표기 사용.
 */
export function UsageBadge({ remaining, daytimeMode }) {
  if (daytimeMode) {
    return <span className={`${styles.badge} ${styles.day}`}>담당자 응대 중</span>;
  }
  if (remaining === null || remaining === undefined) {
    return <span className={styles.badge}>—</span>;
  }
  const low = remaining <= 1;
  return (
    <span className={`${styles.badge} ${low ? styles.low : ''}`}>
      남은 무료 응답 <strong>{remaining}회</strong>
    </span>
  );
}
